const FamilyReunion = () => {
    return (
    <div>
        <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

                <div className="px-1 flex flex-col justify-center lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem]">
                    <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                        Family Reunion (immigration cases)
                    </h1>
                    <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                        A foreign citizen seeking to live permanently with their immediate relatives in the country of their 
                        residence usually requires special immigrant visas. Whether it is an immediate relative, such as a 
                        spouse, child or parent, or a specific, more distant family relationship, often the sponsor is 
                        not available to accompany their family members throughout the process. Visatronix makes such 
                        visa applications hassle-free by taking care of whole process without overwhelming applicants.
                    </p>
                   
                </div>
                <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
                    <img src="/visatronix/Family-Reunion-(ImmigrationCas).jpg" alt="" className="rounded-md max-w-[100%]"/>
                    
                </div>
            </div>

        </div>

    </div>
    )
};
export default FamilyReunion;